var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useAddToCart } from './useAddToCart';
import { FormikProvider } from 'formik';
import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { addToCartError, addToCartSuccess, useTrackProductAdd } from '../components/Mutation/AddToCart/addToCartUtils';
import { uniqueId } from 'lodash';
import { getAddToCartOptimisticResponse } from '../components/Mutation/cartMutationUtils';
import { useCartId } from '../components/Cart/CartIdContext';
export function AddToCartFormik({ product, variant, commentValidators = {}, getMissingOptions, initialValues, 
// Apollo specific props
onAddToCartInit, onAddToCartError, onAddToCartSuccess, cartQuery, cartMutation, 
// Backwards compatability with render props
children }) {
    const client = useApolloClient();
    const [addToCartMutation] = useMutation(cartMutation, {
        onCompleted: () => localStorage.setItem('cartChange', '1')
    });
    const { cartId, setCartId } = useCartId();
    const trackAddProductVariant = useTrackProductAdd(variant);
    function submit({ input, optimistic }) {
        return __awaiter(this, void 0, void 0, function* () {
            trackAddProductVariant(product, input.quantity);
            const mutationId = uniqueId();
            const callbackOptions = {
                product: optimistic.product,
                price: optimistic.price,
                quantity: input.quantity,
                selectedVariation: variant,
                mutationId
            };
            if (onAddToCartInit) {
                onAddToCartInit(callbackOptions);
            }
            return addToCartMutation({
                variables: {
                    input
                },
                optimisticResponse: {
                    addToCart: {
                        cart: getAddToCartOptimisticResponse(optimistic.product, input.quantity, cartId, client, cartQuery),
                        __typename: 'CartMutation'
                    }
                }
            })
                .then(addToCartSuccess({
                onAddToCartSuccess,
                callbackOptions,
                cartId,
                setCartId
            }))
                .catch(addToCartError({
                onAddToCartError,
                callbackOptions
            }));
        });
    }
    const { form } = useAddToCart({
        product,
        variant,
        commentValidators,
        getMissingOptions,
        initialValues,
        submit
    });
    return React.createElement(FormikProvider, { value: form }, children(form));
}
export default AddToCartFormik;
//# sourceMappingURL=AddToCartFormik.js.map